module.exports = __webpack_public_path__ + "static/comp2-ab1b3a235c5d68b9a9e09b22d38dcb4e.png";